import React from "react";
import styled from "styled-components";

import defaultCoverPhoto from "../assets/img/ip-preview-premium.jpg";

import ButtonSpan from "./common/ButtonSpan";

const RestyledButtonSpan = styled(ButtonSpan)`
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.8);
`;

const PurchaseOverlay = styled.div`
  display: none;
  position: absolute;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
  background: rgba(0, 0, 0, 0.7);
  padding: 10px;
  border-radius: 4px;
  color: #eee;
  justify-content: center;
  align-items: center;
`;

const Box = styled.div`
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, .05);
  background: #fff;
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  margin: 20px;
  cursor: pointer;
  transition: all ease-in .15s;
  position: relative;
  overflow: hidden;
  color: #888;
  animation-delay: ${({ animationDelay }) => `${animationDelay}s;`}

  :hover {
    transform: scale(1.1, 1.1);
    box-shadow: 0 10px 40px rgba(0, 0, 0, .2);

    ${PurchaseOverlay} {
      display: flex;
    }
  }

  @media only screen and (max-width: 600px) {
    width: 90%;
    margin: 20px auto;
  }
`;

const PreviewPurchased = styled.span`
  position: absolute;
  top: 5px;
  right: 5px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.65);
  color: #eee;
  padding: 5px 10px 4px;
  text-transform: uppercase;
  font-size: 0.7em;
  font-weight: 900;
`;

const BoxContent = styled.div`
  margin: 0;
`;

const PreviewImage = styled.div`
  background-image: url(${({ backgroundImage }) => backgroundImage});
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
  height: ${({ height }) => height};
  margin: -10px;
  border-radius: 4px 4px 0px 0px;
`;

const PreviewTitle = styled.h2`
  font-weight: 600;
  color: #444;
  font-size: ${({ fontSize }) => fontSize};
  margin-bottom: 5px;
`;

const Description = styled.p`
  ${({ fontSize }) => (fontSize ? `font-size: ${fontSize};` : "")};
`;

const Asset = ({
  translate,
  data: asset,
  data: {
    item: {
      title,
      metadata: {
        preview_title: previewTitle = title,
        preview_description: previewDescription = "",
        paywall_cover_photo: coverPhoto = defaultCoverPhoto,
        preview_button_label: buyButtonLabel = translate("purchase")
      } = {}
    },
    has_access: hasAccess
  },
  token,
  showPaywall,
  animationDelay = 0,
  branding: {
    paywall_buttons_bg_color: bgColor,
    paywall_buttons_text_color: textColor
  },
  boxWidth = "300px",
  boxHeight = "250px",
  previewImgHeight = "170px",
  previewFontSize = "1.3em",
  descriptionFontSize,
  descriptionCharLimit = 0,
  buttonPadding
}) => {
  const brandingStyles = {
    background: bgColor,
    color: textColor
  };

  const description = descriptionCharLimit
    ? `${previewDescription.substr(0, descriptionCharLimit)}...`
    : previewDescription;
  return (
    <Box
      onClick={showPaywall(asset, token)}
      className="animated fadeIn"
      width={boxWidth}
      height={boxHeight}
      animationDelay={animationDelay}
    >
      <BoxContent>
        <PreviewImage height={previewImgHeight} backgroundImage={coverPhoto} />
        <PreviewTitle
          fontSize={previewFontSize}
          dangerouslySetInnerHTML={{ __html: previewTitle }}
        />
        <Description
          fontSize={descriptionFontSize}
          dangerouslySetInnerHTML={{
            __html: description
          }}
        />
      </BoxContent>
      {hasAccess ? (
        <PreviewPurchased>{translate("purchased")}</PreviewPurchased>
      ) : (
        <PurchaseOverlay>
          <RestyledButtonSpan
            padding={buttonPadding}
            {...brandingStyles}
            className="animated bounceIn"
          >
            {buyButtonLabel}
          </RestyledButtonSpan>
        </PurchaseOverlay>
      )}
    </Box>
  );
};

export default Asset;
